__turbopack_context__.v({
  "container": "styles-module__hcduwG__container",
  "description": "styles-module__hcduwG__description",
  "nudges": "styles-module__hcduwG__nudges",
  "productDetails": "styles-module__hcduwG__productDetails",
  "productImage": "styles-module__hcduwG__productImage",
  "productPlaceholder": "styles-module__hcduwG__productPlaceholder",
  "shippingPriceCaption": "styles-module__hcduwG__shippingPriceCaption",
  "text": "styles-module__hcduwG__text",
});
